export default __webpack_public_path__ + "static/media/id.js.ba77ae97.map";